import qs from 'qs';

const Kpi = {
    namespaced: true,

    state: {
        kpiArticleData: [],
    },

    getters: {
        kpiArticleData (state) {
            return state.kpiArticleData;
        },
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['kpiArticleData'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['kpiArticleData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['kpiArticleData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['kpiArticleData'] = state['kpiArticleData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по статьям KPI
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getKpiArticleData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'kpi/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data.map(kpi => {
                            return {
                                kpiId: kpi.kpiId,
                                kpiKey: kpi.kpiKey,
                                kpiTitle: kpi.kpiTitle,
                                ordering: kpi.ordering,
                                roleKey: kpi.roleKey.split(','),
                                kpiPeriod: kpi.kpiPeriod.split(','),
                            }
                        })
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по статьям KPI получены.'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN kpi.js | getKpiArticleData : ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по статьям KPI!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных по статьям KPI
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveKpiArticleData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'kpi/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => {
                    // Если пришла ошибка

                    console.log(response.data);

                    if (response.data[0].lastId !== null && typeof (response.data[0].lastId) !== 'undefined' && response.data[0].lastId === -100) {
                        resolve(response.data[0].ErrorMsg);
                    } else {
                        // Если редактирование
                        if (data.index !== -1) {
                            commit('setItem', {
                                item: data.data,
                                index: data.index
                            });
                            dispatch('loading/isLoading', false, {root: true});
                            window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по статье KPI успешно отредактированы!');

                            // Если сохранение нового
                        } else {
                            data.data.kpiId = response.data[0].kpiId;
                            commit('addItem', {
                                item: data.data
                            });
                            dispatch('loading/isLoading', false, {root: true});
                            window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новая статья KPI успешно создана!');
                        }
                        resolve();
                    }
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN kpi.js | saveKpiArticleData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление статьи KPI
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeKpiArticleData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'kpi/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Статья KPI успешно удалены!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении статьи KPI!'),
                    console.log('ERROR IN kpi.js | removeKpiArticleData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Kpi;





// WEBPACK FOOTER //
// ./src/store/modules/kpi.js